
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false,\"url\":true,\"alias\":{\"fonts\":\"..fonts\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-26100638\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CabecalhoDoConteudo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CabecalhoDoConteudo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-26100638\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CabecalhoDoConteudo.vue"),
  /* scopeId */
  "data-v-26100638",
  /* cssModules */
  null
)
Component.options.__file = "/app/src/components/shared/CabecalhoDoConteudo.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CabecalhoDoConteudo.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26100638", Component.options)
  } else {
    hotAPI.reload("data-v-26100638", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/shared/CabecalhoDoConteudo.vue
// module id = 1074
// module chunks = 1